import React from 'react';
import { useGameStore } from '../store/gameStore';
import { ChevronLeft, Globe, Activity, Clock, ShieldCheck, Target } from 'lucide-react';
import { Tooltip } from './Tooltip';
import clsx from 'clsx';

export const TheaterHeader: React.FC = () => {
  const { reset, turn, maxTurns, ap, maxAp, sectors } = useGameStore();

  const blueControl = sectors.filter(s => s.owner === 'Blue').length;
  const redControl = sectors.filter(s => s.owner === 'Red').length;

  return (
    <header className="w-full z-50 p-4 pointer-events-none">
      <div className="max-w-7xl mx-auto flex items-center justify-between pointer-events-auto">
        
        {/* Left: Return to Lobby */}
        <div className="flex items-center gap-4">
          <Tooltip content="Return to Lobby">
            <button 
              onClick={reset}
              className="flex items-center gap-2 px-4 py-2 bg-slate-900/90 border border-slate-700 rounded-lg text-slate-300 hover:text-white hover:bg-slate-800 hover:border-slate-500 transition-all shadow-lg group"
            >
              <ChevronLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
              <span className="font-bold tracking-wide text-sm">LOBBY</span>
            </button>
          </Tooltip>

          {/* Title / Context */}
          <div className="hidden md:flex items-center gap-3 px-4 py-2 bg-slate-900/80 border-l border-slate-700">
            <Globe className="w-4 h-4 text-ops-blue" />
            <span className="text-slate-400 font-mono text-sm tracking-widest uppercase">Theater Command</span>
          </div>
        </div>

        {/* Right: Game Status */}
        <div className="flex items-center gap-3 bg-slate-900/90 border border-slate-700 rounded-lg p-1.5 shadow-lg backdrop-blur-md">
          
          {/* Turn Counter */}
          <div className="flex items-center gap-2 px-3 py-1 border-r border-slate-800">
            <Clock className="w-4 h-4 text-slate-500" />
            <div className="flex flex-col leading-none">
              <span className="text-[10px] text-slate-500 font-bold uppercase">Turn</span>
              <span className="text-slate-200 font-mono font-bold">{turn}/{maxTurns}</span>
            </div>
          </div>

          {/* AP Counter */}
          <div className="flex items-center gap-2 px-3 py-1 border-r border-slate-800">
            <Activity className={clsx("w-4 h-4", ap > 0 ? "text-ops-green" : "text-slate-600")} />
            <div className="flex flex-col leading-none">
              <span className="text-[10px] text-slate-500 font-bold uppercase">AP</span>
              <span className="text-slate-200 font-mono font-bold">{ap}/{maxAp}</span>
            </div>
          </div>

          {/* Control Balance */}
          <div className="flex items-center gap-4 px-3 py-1">
            <div className="flex items-center gap-1.5">
              <ShieldCheck className="w-3.5 h-3.5 text-blue-500" />
              <span className="text-blue-400 font-mono font-bold">{blueControl}</span>
            </div>
            <div className="h-4 w-px bg-slate-800" />
            <div className="flex items-center gap-1.5">
              <Target className="w-3.5 h-3.5 text-red-500" />
              <span className="text-red-400 font-mono font-bold">{redControl}</span>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
};
